








import { Component, Emit, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'

@Component
export default class AtomIconHelp extends ComponentVue {
  @Prop({
    type: String,
    default: '2x'
  })
  size!: string

  @Emit('click')
  onClick() {}
}
